import { DelayedRender } from "@jugl-web/ui-kit";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { FC, useEffect, useMemo, useRef } from "react";
import { ChatMessageBubble } from "../ChatBotMessageComponent/components/ChatMessageBubble";
import typingAnimation from "./assets/typing-animation.json";

interface TypingIndicatorBubbleProps {
  userBubbleColor: string;
  agentName: string;
  agentImageUrl?: string;
}

export const TypingIndicatorBubble: FC<TypingIndicatorBubbleProps> = ({
  userBubbleColor,
  agentName,
  agentImageUrl,
}) => {
  const chatMessageBubbleRef = useRef<HTMLDivElement>(null);

  // Scroll the the bubble on mount
  useEffect(() => {
    if (chatMessageBubbleRef.current) {
      chatMessageBubbleRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <ChatMessageBubble
      ref={chatMessageBubbleRef}
      isOutgoing={false}
      userBubbleColor={userBubbleColor}
      senderName={agentName}
      senderImageUrl={agentImageUrl}
    >
      <Lottie
        className="justify-start"
        options={{ animationData: typingAnimation }}
        height={32}
        width={26}
      />
    </ChatMessageBubble>
  );
};

/**
 * Adds some random delay before showing the typing indicator bubble to make it more natural
 */
export const DelayedTypingIndicatorBubble: FC<TypingIndicatorBubbleProps> = (
  props
) => {
  const typingDelayMs = useMemo(() => Math.random() * 1500 + 500, []);

  return (
    <DelayedRender
      isLoading
      delayMs={typingDelayMs}
      loadingContent={<TypingIndicatorBubble {...props} />}
    />
  );
};
